// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DailyAttendance */

.timeline-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center; /* helps center contents inside */
    margin-top: 20px;
  }
  .timeline-progress-bar {
    position: relative;
    height: 24px;             /* keep your original height */
    width: 70%;               /* reduce width as needed (e.g., 60% of parent) */
    margin: 0 auto;           /* center horizontally */
    background-color: #eee;
    border-radius: 12px;
    overflow: hidden;
    transform: translateZ(0);
  }
  
  .timeline-segment {
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    border-radius: 4px;
    cursor: pointer;
    opacity: 0.9;
  }
  
  .timeline-segment.orange {
    background-color: orange;
  }
  
  .timeline-segment.green {
    background-color: green;
  }
  
  
  .timeline-segment:hover {
    opacity: 1;
  }
  
  .time-ruler {
    position: relative;
    margin-top: 5px;
    height: 20px;
    width: 100%;
  }
  
  .ruler-label {
    position: absolute;
    font-size: 12px;
    color: #555;
    white-space: nowrap;
    -webkit-user-select: none;
            user-select: none;
  }
  
  /* Box styles from your Box sx prop - can be refined or overridden */
  .personalInfo-logo {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
  
  .acc-title {
    font-weight: bold;
    font-size: 20px;
  }
  
  /* Optional - for the green checkmark style */
  span {
    margin-left: 8px;
  }
  
  /* Additional spacing and alignment adjustments */
  .box-flex {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  /* Responsive */
  @media (max-width: 600px) {
    .timeline-container {
      height: 25px;
    }
    
    .ruler-label {
      font-size: 10px;
    }
  }

  /* .checkout-marker {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1.5px; 
    background-color: red;
    z-index: 2;
  } */
  .checkout-marker {
    position: absolute;
    top: 0;
    height: 100%;
    width: 2px;
    background-color: red;
    z-index: 3;
    transform: translateX(-1px); /* Slight offset to pixel-align */
  }`, "",{"version":3,"sources":["webpack://./src/views/panel/employeeRoster/DailyAttendance.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,iCAAiC;IACtD,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY,cAAc,8BAA8B;IACxD,UAAU,gBAAgB,iDAAiD;IAC3E,cAAc,YAAY,wBAAwB;IAClD,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;;EAGA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA,oEAAoE;EACpE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,6CAA6C;EAC7C;IACE,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA,eAAe;EACf;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;;;;;;;KAOG;EACH;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV,2BAA2B,EAAE,iCAAiC;EAChE","sourcesContent":["/* DailyAttendance */\n\n.timeline-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* helps center contents inside */\n    margin-top: 20px;\n  }\n  .timeline-progress-bar {\n    position: relative;\n    height: 24px;             /* keep your original height */\n    width: 70%;               /* reduce width as needed (e.g., 60% of parent) */\n    margin: 0 auto;           /* center horizontally */\n    background-color: #eee;\n    border-radius: 12px;\n    overflow: hidden;\n    transform: translateZ(0);\n  }\n  \n  .timeline-segment {\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    border-radius: 4px;\n    cursor: pointer;\n    opacity: 0.9;\n  }\n  \n  .timeline-segment.orange {\n    background-color: orange;\n  }\n  \n  .timeline-segment.green {\n    background-color: green;\n  }\n  \n  \n  .timeline-segment:hover {\n    opacity: 1;\n  }\n  \n  .time-ruler {\n    position: relative;\n    margin-top: 5px;\n    height: 20px;\n    width: 100%;\n  }\n  \n  .ruler-label {\n    position: absolute;\n    font-size: 12px;\n    color: #555;\n    white-space: nowrap;\n    user-select: none;\n  }\n  \n  /* Box styles from your Box sx prop - can be refined or overridden */\n  .personalInfo-logo {\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n  }\n  \n  .acc-title {\n    font-weight: bold;\n    font-size: 20px;\n  }\n  \n  /* Optional - for the green checkmark style */\n  span {\n    margin-left: 8px;\n  }\n  \n  /* Additional spacing and alignment adjustments */\n  .box-flex {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  /* Responsive */\n  @media (max-width: 600px) {\n    .timeline-container {\n      height: 25px;\n    }\n    \n    .ruler-label {\n      font-size: 10px;\n    }\n  }\n\n  /* .checkout-marker {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 1.5px; \n    background-color: red;\n    z-index: 2;\n  } */\n  .checkout-marker {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    width: 2px;\n    background-color: red;\n    z-index: 3;\n    transform: translateX(-1px); /* Slight offset to pixel-align */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
